/**
 * Permission text utilities (English only)
 */

// Keep empty dictionaries to avoid breaking imports; no translations needed.
export const permissionSetNameTranslations = {};

export const translatePermissionSetName = (name) => name;

export const moduleTranslations = {};

export const translateModuleName = (moduleName) => moduleName;

export const permissionActionTranslations = {};

export const translatePermissionAction = (action) => action;

// Format actions as an English sentence
export const formatActionsAsSentence = (model, actions) => {
    const m = translateModuleName(model);
    const acts = actions.map(translatePermissionAction);
    if (acts.length === 0) return `This role has no actions on ${m}`;
    if (acts.length === 1) return `This role allows to ${acts[0]} ${m}`;
    if (acts.length === 2) return `This role allows to ${acts[0]} and ${acts[1]} ${m}`;
    const last = acts[acts.length - 1];
    const rest = acts.slice(0, -1).join(', ');
    return `This role allows to ${rest}, and ${last} ${m}`;
};